module.exports = __webpack_public_path__ + "anguilla.svg?439212b4b789380eed9aabee53afb238";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/anguilla.svg
// module id = 92
// module chunks = 10